<template>
  <v-dialog v-model="localDialogVisible" max-width="600px">
    <v-card v-if="selectedEvaluation" class="elevation-12">
      <v-card-title class="headline primary white--text">
        <span v-if="!isEditing" class="white--text">{{ selectedEvaluation.title }}</span>
        <v-text-field
          v-else
          v-model="editedTitle"
          label="Tên đánh giá"
          dense
          outlined
          hide-details
          class="mt-2"
          @keyup.enter="saveTitle"
          dark
          color="white"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleEditing" v-if="!isEditing">
          <v-icon color="white">mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon @click="saveTitle" v-else>
          <v-icon color="white">mdi-check</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-icon small color="indigo" class="mr-2">mdi-teach</v-icon>
            <strong>Lớp:</strong> {{ selectedEvaluation.class ? selectedEvaluation.class.title : '' }}
          </v-col>
          <v-col cols="12" sm="6">
            <v-icon small color="green" class="mr-2">mdi-clock-outline</v-icon>
            <strong>Thời gian:</strong> {{ formatDate(selectedEvaluation.time) }}
          </v-col>
          <v-col cols="12" sm="6">
            <v-icon small color="orange" class="mr-2">mdi-format-list-bulleted-type</v-icon>
            <strong>Loại:</strong> {{ getEvaluationType(selectedEvaluation.type) }}
          </v-col>
          <v-col cols="12" sm="6">
            <v-icon small color="blue" class="mr-2">mdi-check-circle-outline</v-icon>
            <strong>Đã đánh giá:</strong> {{ selectedEvaluation.totalEvaluated }}
          </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <h3 class="mb-3 font-weight-medium black--text">Tiêu chí đánh giá</h3>
        <v-list>
          <v-list-item v-for="(criteria, index) in selectedEvaluation.evaluate_criteria" :key="index" class="mb-2 pa-0">
            <v-list-item-icon>
              <v-icon color="primary">mdi-checkbox-marked-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="pa-0 mb-2">
              <v-list-item-title class="font-weight-medium">{{ criteria.title }}</v-list-item-title>
              <v-list-item-subtitle> Loại: {{ getCriteriaType(criteria.type) }} </v-list-item-subtitle>
              <v-list-item-subtitle v-if="criteria.type === 'singlechoice' || criteria.type === 'multiplechoice'">
                Lựa chọn: {{ criteria.selections.join(', ') }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-else-if="criteria.type === 'string'"> Nhập văn bản </v-list-item-subtitle>
              <v-list-item-subtitle v-else-if="criteria.type === 'number'"> Nhập số </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider class="my-4"></v-divider>
        <div class="d-flex align-items-center">
          <ExportEvaluate :evaluate-id="selectedEvaluation.id" />
          <SendMessageEvaluate :evaluate-id="selectedEvaluation.id" />
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn class="text-uppercase" color="error" text @click="confirmDelete">
          <v-icon left>mdi-delete</v-icon>
          Xóa đánh giá
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog"> Đóng </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ExportEvaluate from './ExportEvaluate.vue'
import SendMessageEvaluate from './SendMessageEvaluate.vue'
export default {
  components: {
    ExportEvaluate,
    SendMessageEvaluate,
  },
  props: {
    selectedEvaluation: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      localDialogVisible: false,
      isEditing: false,
      editedTitle: '',
    }
  },
  methods: {
    closeDialog() {
      this.localDialogVisible = false
      this.isEditing = false
    },
    openDialog() {
      this.localDialogVisible = true
      if (this.selectedEvaluation) {
        this.editedTitle = this.selectedEvaluation.title
      }
    },
    formatDate(dateString) {
      return dateString ? new Date(dateString).toLocaleString('vi-VN') : ''
    },
    getEvaluationType(type) {
      const types = {
        session: 'Buổi học',
        week: 'Tuần',
        month: 'Tháng',
        custom: 'Tùy chỉnh',
      }
      return types[type] || type
    },
    getCriteriaType(type) {
      const types = {
        singlechoice: 'Chọn một',
        multiplechoice: 'Chọn nhiều',
        string: 'Văn bản',
        number: 'Số',
      }
      return types[type] || type
    },
    toggleEditing() {
      this.isEditing = !this.isEditing
      if (this.isEditing && this.selectedEvaluation) {
        this.editedTitle = this.selectedEvaluation.title
      }
    },
    saveTitle() {
      if (this.editedTitle && this.editedTitle.trim() !== '') {
        this.$emit('update-title', { id: this.selectedEvaluation.id, newTitle: this.editedTitle })
        this.isEditing = false
      }
    },
    confirmDelete() {
      if (this.selectedEvaluation && confirm('Bạn có chắc chắn muốn xóa đánh giá này?')) {
        this.$emit('delete-evaluation', this.selectedEvaluation.id)
        this.closeDialog()
      }
    },
  },
}
</script>
